import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import { Link } from 'react-router-dom';

export class Ver_collection_products extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleAssignProduct = this.handleAssignProduct.bind(this);
        this.removeProduct = this.removeProduct.bind(this);

        this.state = {
            collection: null,
            products: [],
            allProducts: [],
            openProductModal: false,
            selectedProduct: null,
        };
    }

    componentWillMount() {
        this.getDataCollection();
        this.getDataCollectionProducts();
        this.getDataAllProducts();
    }

    onOpenModal = () => {
        this.setState({ openProductModal: true });
    };

    onCloseModal = () => {
        this.setState({
            openProductModal: false,
            selectedProduct: null,
        });
    };

    getDataCollection(){
        var user = AuthService.getCurrentUser();
        let id_collection = this.props.match.params.id;
        ApiService.getProductCollectionDetails(user.token, id_collection).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    this.setState({
                        collection: res.data,
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    getDataCollectionProducts(){
        var user = AuthService.getCurrentUser();
        let id_collection = this.props.match.params.id;
        ApiService.getCollectionProducts(user.token, id_collection).then(
            (res) => {
                if(res && res.status === 'success'){
                    this.setState({ products: res.data });
                }
            },
            error => {
            }
        );
    }

    getDataAllProducts(){
        var user = AuthService.getCurrentUser();
        ApiService.getProducts(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    // Filtrar solo productos activos (ACTIVATED)
                    const products = res.data
                        .filter(row => row.status === 'ACTIVATED')
                        .map(function(row) {
                            return {
                                value: row.id,
                                label: row.name + (row.price ? ` - $${row.price}` : '')
                            }
                        });
                    this.setState({ allProducts: products });
                }
            },
            error => {
            }
        );
    }

    handleProductChange = (selectedOption) => {
        this.setState({ selectedProduct: selectedOption });
    };

    handleAssignProduct = () => {
        var user = AuthService.getCurrentUser();
        let id_collection = this.props.match.params.id;

        if (!this.state.selectedProduct) {
            Swal.fire("Por favor selecciona un producto.");
            return;
        }

        // Verificar si el producto ya está asignado
        const alreadyAssigned = this.state.products.some(
            item => item.id_product === this.state.selectedProduct.value
        );

        if (alreadyAssigned) {
            Swal.fire("Este producto ya está asignado a la colección.");
            return;
        }

        let data = {
            id_collection: id_collection,
            id_product: this.state.selectedProduct.value
        };

        ApiService.assignProductToCollection(user.token, data).then(
            (res) => {
                if(res){
                    if(res.status == 'success'){
                        toast.success(res.message);
                        this.onCloseModal();
                        this.getDataCollectionProducts();
                    }
                    else{
                        toast.error(res.message);
                    }
                }
            },
            error => {
                toast.error("Ha ocurrido un error al asignar el producto!");
            }
        );
    };

    removeProduct(assignmentId, productName) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea remover ' + productName + ' de esta colección?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                var user = AuthService.getCurrentUser();
                ApiService.removeProductFromCollection(user.token, assignmentId).then(
                    (res) => {
                        toast.success("Producto removido de la colección!");
                        this.getDataCollectionProducts();
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                        toast.error("Error al remover producto");
                    }
                )
            }
        })
    }

    render() {
        const { collection, products } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Productos de la Colección" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>
                                        {collection ? `Productos de: ${collection.collection_name}` : 'Productos de la Colección'}
                                    </h5>
                                </div>
                                <div className="card-body">
                                    {collection && (
                                        <div className="alert alert-info mb-3">
                                            <strong>Colección:</strong> {collection.collection_name}
                                            {collection.collection_code && <span> ({collection.collection_code})</span>}
                                            {collection.description && <><br/><strong>Descripción:</strong> {collection.description}</>}
                                        </div>
                                    )}

                                    <div className="btn-popup pull-right">
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.onOpenModal}
                                        >
                                            Agregar Producto
                                        </button>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="table-responsive mt-3">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Producto</th>
                                                    <th>Precio</th>
                                                    <th>Estado</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No hay productos en esta colección
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    products.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.Product ? item.Product.name : '-'}</td>
                                                            <td>${item.Product && item.Product.price ? item.Product.price : '0.00'}</td>
                                                            <td>
                                                                {item.Product && item.Product.status === 'ACTIVATED'
                                                                    ? <span className="badge badge-success">ACTIVO</span>
                                                                    : <span className="badge badge-danger">INACTIVO</span>
                                                                }
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => this.removeProduct(item.id, item.Product ? item.Product.name : 'este producto')}
                                                                    title="Remover"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="mt-3">
                                        <Link to="/product-collections" className="btn btn-secondary">
                                            Volver a Colecciones
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={this.state.openProductModal} onClose={this.onCloseModal} center>
                    <div className="modal-header">
                        <h5 className="modal-title">Agregar Producto a la Colección</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label><strong>Colección:</strong> {collection ? collection.collection_name : ''}</label>
                        </div>
                        <div className="form-group">
                            <label>Seleccionar Producto</label>
                            <Select
                                value={this.state.selectedProduct}
                                onChange={this.handleProductChange}
                                options={this.state.allProducts}
                                placeholder="Selecciona un producto..."
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.onCloseModal}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleAssignProduct}
                        >
                            Agregar Producto
                        </button>
                    </div>
                </Modal>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_collection_products
